<div class="wrap-box">
  <div class="box">
    <form [formGroup]="form" *ngIf="form">
      <div class="header">
        <span>ราคา</span>
        <span class="itax-dropdown">
            <app-dropdown [items]="dropdownItems"
                          id="calType"
                          [(selected)]="selectedItem"
                          (valueChange)="onDdlItemClick($event)">
            </app-dropdown>
        </span>
      </div>
      <div class="mb-20px wrap-input">
        <app-input-number [(value)]="total"
                          (valueChange)='onNumberChange()'>
        </app-input-number>
      </div>
      <div class="row d-flex align-items-center mb-10px">
        <div class="col pl-0">
          ภาษีมูลค่าเพิ่ม (VAT)
        </div>
        <div class="col input-tax">
          <div class="input-group mb-0">
            <input type="text" class="form-control" placeholder="" inputmode="decimal"
              formControlName="vat"
              itaxNumberOnly
            />
            <span class="wrap-percent">%</span>
          </div>
        </div>
      </div>
      <div class="row d-flex align-items-center mb-20px">
        <div class="col pl-0">
          หักภาษี ณ ที่จ่าย
        </div>
        <div class="col input-tax">
          <div class="input-group mb-0">
            <input type="text" class="form-control" placeholder="" inputmode="decimal"
              formControlName="tax"
              itaxNumberOnly
            />
            <span class="wrap-percent">%</span>
          </div>
        </div>
      </div>
      <div class="mb-20px">
        <app-select-group 
          [(selected)]="selectedUserType" 
          (selectedChange)="onUserTypeChanged($event)"
          [items]="userTypeOptions"
          [isError]="isUserTypeError"
        ></app-select-group>
      </div>
      <div *ngIf="selectedUserType == 'receiver'" class="mb-20px">
        <div class="collapse-trigger d-flex" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed">
          <span class="p1 mr-auto">ระบุช่องทางรับชำระเงิน</span>
          <span class="arrow">
            <img src="/assets/images/ico-arrow-down-grey.svg" width="24" height="24" />
          </span>
        </div>
        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
          <div class="wrap-bank-select mt-20px">
            <div class="inner">
              <div *ngFor="let item of BankList" (click)="selectBank(item.value)" [ngClass]="{'active': (item.value==selectedBank)}">
                <img src="/assets/images/bank/ico-{{item.value}}.webp" width="40" height="40" />
              </div>
            </div>
          </div>
          <div *ngIf="selectedBank">
            <div>
              <div class="p1 mb-5px">{{ accountNoLabel }}</div>
              <div class="input-group mb-15px">
                <input  type="text" 
                        class="form-control p1" 
                        inputmode="decimal" 
                        [ngClass]="{'error': isAccountNoError}" 
                        placeholder="ระบุ" 
                        [maxLength]="accountNoMaxLength"
                        [(ngModel)]="accountNo" 
                        (ngModelChange)="onAccountNoChanged($event)" 
                        [ngModelOptions]="{standalone: true}" 
                itaxNumberOnly />
              </div>
            </div>
            <div *ngIf="selectedBank && !isPromptpay()">
              <div class="p1 mb-5px">ชื่อบัญชี</div>
              <div class="input-group mb-20px">
                <input type="text" class="form-control p1" placeholder="ระบุ" [(ngModel)]="accountName" [ngModelOptions]="{standalone: true}" />
              </div>
            </div>
            <itax-left-checkbox [id]="'consent'"
                                [label]="'จำข้อมูลนี้ไว้ใช้ครั้งต่อไป'"
                                [(checked)]="isConsent"
                                (valueChange)="onConsentChanged($event)">
            </itax-left-checkbox>
            <div class="wrap-consent-text text-gray-medium mb-20px mt-5px">บันทึกช่องทางชำระเงินและใช้คุกกี้เพื่อไม่ต้องกรอกซ้ำ สามารถลบได้ทุกเมื่อ</div>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-primary btn-block py-12px"
              (click)="submit()">
        คำนวณ
      </button>
      <div class="text-error text-center p1 mt-10px" *ngIf="isUserTypeError || isAccountNoError">
        กรุณาระบุข้อมูลให้ครบถ้วน
      </div>
    </form>
  </div>
</div>
